import { useMemo } from 'react';

import { DataPipeline } from '@finley-technologies/finley-types';
import { DbGraphUtils } from '@finley-technologies/tape-builder';

import { useGetLatestMeshDocumentsQuery } from 'packages/dataPipeline/requests/dataPipeline.gql.generated';
import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';

export const useLatestMeshDocuments = ({
  organizationId,
}: {
  organizationId: string;
}): {
  latestMeshDocuments: DataPipeline.MeshDocument[];
  loading: boolean;
  error?: Error;
} => {
  const flags = useFeatureFlags();
  const { data, loading, error } = useGetLatestMeshDocumentsQuery({
    variables: {
      organizationId,
      creditFacilitySlugsToHide: flags.creditFacilitySlugsToHide ?? [],
    },
  });

  const latestMeshDocuments = useMemo(() => {
    return (
      data?.latestMeshDocuments.map((meshDocumentStr) => {
        return DbGraphUtils.deserializeMeshDocument(meshDocumentStr);
      }) || []
    );
  }, [data?.latestMeshDocuments]);

  return {
    latestMeshDocuments,
    loading,
    error,
  };
};
